import React from 'react';
import { Button, FormGroup, HelpBlock, Image, Panel } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { Link } from '../Link.jsx';
import FieldGroup from '../FieldGroup.jsx';

function ResetPasswordForm(props) {
  return (
    <Panel>
      <Panel.Body>
        <Link route="index">
          <a title="Sign in">
            <Image
              alt="ChangeSync Logo"
              className="component-margin-bottom"
              src="/static/images/logo.svg"
              responsive
            />
          </a>
        </Link>
        <p className="component-margin-bottom text-center">
          Finish resetting your password by setting a new password below.
        </p>
        <form onSubmit={props.handleSubmit}>
          <Field
            id="password"
            name="password"
            label="Password"
            type="password"
            component={FieldGroup}
            disabled={props.submitSucceeded}
          />
          <Field
            id="passwordConfirmation"
            name="passwordConfirmation"
            label="Confirm Password"
            type="password"
            component={FieldGroup}
            disabled={props.submitSucceeded}
          />
          {props.submitFailed && (
            <FormGroup validationState="error">
              <HelpBlock>{props.submitError}</HelpBlock>
            </FormGroup>
          )}
          {props.submitSucceeded && (
            <FormGroup>
              <HelpBlock>
                Your password has been updated.
                <br />
                Please{' '}
                <Link route="index">
                  <a>sign in</a>
                </Link>{' '}
                with your new password.
              </HelpBlock>
            </FormGroup>
          )}
          <Button
            block
            bsSize="lg"
            bsStyle="primary"
            disabled={props.submitting || props.submitSucceeded}
            type="submit"
          >
            {!props.submitting && !props.submitSucceeded && 'Update Password'}
            {props.submitting && 'Updating Password...'}
            {props.submitSucceeded && 'Password Updated'}
          </Button>
        </form>
      </Panel.Body>
    </Panel>
  );
}

export default ResetPasswordForm;
